import {
  captureEvent,
  extractErrorProperties,
} from "context/posthog/captureEvent";
import { POSTHOG_EVENTS } from "context/posthog/events";

const STORAGE_NAME = "preload-error-reloaded-at";
// A freshly reloaded page failing again this soon means the chunk is really
// unreachable, so let the error surface instead of reloading in a loop.
const RELOAD_COOLDOWN_MS = 60_000;

// Vite dispatches `vite:preloadError` for every failed dynamic import it emits,
// including the ones inside dependencies that `lazyRetry` cannot wrap, e.g. the
// per-country chunks of the design system's `FlagIcon`. The browser caches a
// failed module fetch for that URL, so a reload is the only way to recover.
export function reloadOnPreloadError(event: VitePreloadErrorEvent) {
  const lastReloadAt = Number(sessionStorage.getItem(STORAGE_NAME));

  if (Date.now() - lastReloadAt < RELOAD_COOLDOWN_MS) {
    return;
  }

  sessionStorage.setItem(STORAGE_NAME, String(Date.now()));

  captureEvent(
    POSTHOG_EVENTS.chunkLoadReloadTriggered,
    { chunkName: event.type, ...extractErrorProperties(event.payload) },
    { transport: "sendBeacon", send_instantly: true }
  );

  window.location.reload();
}
